export default __webpack_public_path__ + "static/media/Address.7d25eeb0.svg";